const classPrefix = 'main-price-banner'
const dataPrefix = 'data-main-price-banner'
const $container = document.querySelector(`[${dataPrefix}]`)

if ($container) {
    //summaryResults({$container})
}

export function mainPriceBanner({$container}) {

}




